export default {
  seeCoverageDetails: {
    id: 'insurance_policy_details_see_coverage_details',
    defaultMessage: 'See coverage details',
  },
  coverageDetailsDrawerTitle: {
    id: 'insurance_policy_details_coverage_details_drawer_title',
    defaultMessage: 'Coverage details',
  },
}
